import { createTheme } from "@mui/material";

export const defaultTheme = createTheme({
  palette: {
    mode: "light",

    // Primary & Secondary
    primary: {
      main: "#343a40",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#19a437",
      contrastText: "#ffffff",
    },

    // Backgrounds
    background: {
      default: "#f6f8fa",
      paper: "#ffffff",
      menu: "#ffffff",
      menuHover: "#f0f0f0", // updated
      menuSelected: "#0c3353",
    },

    // Text
    text: {
      primary: "#0b0b0b",
      secondary: "#4a4a4a",
      menuSelected: "#ffffff",
    },

    // Custom palette
    custom: {
      successLight: "#d4edda",
      successMain: "#28a745",
      successDark: "#1e7e34",

      errorLight: "#f8d7da",
      errorMain: "#dc3545",
      errorDark: "#a71d2a",

      warningLight: "#fff3cd",
      warningMain: "#ffc107",
      warningDark: "#d39e00",

      infoLight: "#d1ecf1",
      infoMain: "#17a2b8",
      infoDark: "#117a8b",

      neutralLight: "#f6f8fa",
      neutralMain: "#adb5bd",
      neutralDark: "#495057",
    },
  },

  shape: {
    borderRadius: 12,
  },

  typography: {
    fontFamily: `Vazir-Medium`,
    myTitle: {
      fontFamily: 'BTitr', // custom font
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },

  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#0c3353',
          color: '#fff',
          fontWeight: 'bold',
        },
      },
    },
     MuiButton: {
      styleOverrides: {
        root: {
          padding: "10px 24px",
          // fontFamily: 'BTitr', // change font for all buttons
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#c5c5c5",
          },
          "&.Mui-selected": {
            backgroundColor: "#0c3353",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#0a2945",
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#bdbdbd',
            color: '#212121',
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#9e9e9e',
          },
          '&:hover': {
            backgroundColor: '#d6d6d6',
          },
        },
      },
    },
    // MuiDrawer: {
    //   styleOverrides: {
    //     paper: {
    //       backgroundColor: '#cfcecf', // your custom color
    //     },
    //   },
    // },
  },
});

const themes = { defaultTheme };
export default themes;
